import EndUsersAccountsTable from './tables';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import reducer from '../store';
import withReducer from 'app/store/withReducer';
import { usePermission , usePusher } from '@fuse/hooks';
import { setSerialNumberForServiceRequest } from '../store/filterParamsReducer';
import { openFormViewerDialog,closeFormViewerDialog } from '../store/formViewDialogReducer';
import useCurrentUser from '@fuse/hooks/useCurrentUser';
import SaveReportDialog from '../../reports/components/saveReportDialog';

function CardedFullWidth2TabbedSample(props) {
	const dispatch = useDispatch();
	const [page, setPage] = useState(0);
	const { hasPermission } = usePermission();
	const viewServiceRequestPermission = hasPermission('view-service_request')
	const createServiceRequestPermission = hasPermission('add-service_request')
	const updateServiceRequestPermission = hasPermission('update-service_request')
	const deleteServiceRequestPermission = hasPermission('delete-service_request')
	const [loading, setLoading] = useState(false);
	const {broadcastChannel} = usePusher()
	const new_incident_event = "permission_change"
	const NEW_TICKET_CREATED_FROM_USER = 'new_service_request_created_from_user'
	const NEW_MESSAGE_FROM_USER = 'service_req_chat_new_message_from_user'
	const SERVICE_REQ_ARCHIVE_AND_RESTORE_BY_USER = 'service_req_archive_and_restore_by_user'
	const user = useCurrentUser();
	const [selectedTab, setSelectedTab] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(20);
	const openState = useSelector((state) => state.ServiceRequestsApp.formViewDialog)
	const serial_number = useSelector(({ServiceRequestsApp})=>ServiceRequestsApp.filterParamsReducer.serial_number)
	const [ redirectedWith, setRedirectedWith ] = useState(null);
	const getServiceRequest = () => {window.dispatchEvent(new Event('refreshServiceRequestList'))};

	useEffect(()=>{
		if(serial_number){
			dispatch(openFormViewerDialog())
		}

		// call on component unmount
		return(()=>{
			dispatch(setSerialNumberForServiceRequest(null))
			dispatch(closeFormViewerDialog())
		})
	},[]);

	useEffect(()=>{
		if(broadcastChannel){
			broadcastChannel.bind(new_incident_event, data => {
				if(data.user_companies_id == user.data.user_companies_id){
					location.reload();
				}
			});

			broadcastChannel.bind(NEW_TICKET_CREATED_FROM_USER, () => {
				getServiceRequest();
			});

			broadcastChannel.bind(NEW_MESSAGE_FROM_USER, () => {
				getServiceRequest();
			});

			broadcastChannel.bind(SERVICE_REQ_ARCHIVE_AND_RESTORE_BY_USER, () => {
				getServiceRequest();
			});

			return () => {
				broadcastChannel.unbind(new_incident_event)
				broadcastChannel.unbind(NEW_TICKET_CREATED_FROM_USER)
				broadcastChannel.unbind(NEW_MESSAGE_FROM_USER)
				broadcastChannel.unbind(SERVICE_REQ_ARCHIVE_AND_RESTORE_BY_USER)
			}
		}
	},[broadcastChannel])

	return (
		<div>
			<SaveReportDialog tableName="service request"/>
			<div className='px-32'>
				<div className={selectedTab !== 0 ? 'hidden' : ''}>
					<EndUsersAccountsTable
						page={page}
						setPage={setPage}
						rowsPerPage={rowsPerPage}
						setRowsPerPage={setRowsPerPage}
						loading={loading}
						tableName='serviceRequest'
						customFilterData={redirectedWith}
						viewServiceRequestPermission = {viewServiceRequestPermission}
						createServiceRequestPermission = {createServiceRequestPermission}
						updateServiceRequestPermission = {updateServiceRequestPermission}
						deleteServiceRequestPermission = {deleteServiceRequestPermission}
					/>
					{/* {openState.open && <AddServiceRequestFormDialog getServiceRequest = {getServiceRequest}/>} */}
				</div>
			</div>
		</div>
	)
}

export default withReducer('ServiceRequestsApp', reducer)(CardedFullWidth2TabbedSample);
